import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Button } from "react-bootstrap";
import { AppLoader } from "../../Components/common/AppLoader/AppLoader";
import { fetchDoctorById, fetchDegrees, fetchSpecializations, getDoctorIdFromSlug } from "../../api/doctorApi";
import { mapDoctorToProfile } from "../../utils/doctorHelpers";
import DoctorProfileView from "./DoctorProfileView";
import "./doctor-profiles.css";

export const DoctorProfilePage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [doctor, setDoctor] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setError("");

      const doctorId = getDoctorIdFromSlug(slug);
      if (!doctorId) {
        setDoctor(null);
        setError("Doctor profile not found.");
        setLoading(false);
        return;
      }

      try {
        const [doc, degrees, specializations] = await Promise.all([
          fetchDoctorById(doctorId),
          fetchDegrees(),
          fetchSpecializations(),
        ]);

        if (cancelled) return;
        const mapped = mapDoctorToProfile(doc, { degrees, specializations });
        setDoctor(mapped);

        if (mapped.slug && mapped.slug !== slug) {
          navigate(`/doctors/${mapped.slug}`, { replace: true });
        }
      } catch (err) {
        if (!cancelled) {
          setDoctor(null);
          setError(err.message || "Doctor profile not found.");
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => { cancelled = true; };
  }, [slug, navigate]);

  if (loading) {
    return (
      <div className="dp-profile-page dp-profile-page--empty">
        <Container className="text-center py-5">
          <AppLoader variant="page" />
        </Container>
      </div>
    );
  }

  if (error || !doctor) {
    return (
      <div className="dp-profile-page dp-profile-page--empty">
        <Container>
          <p>{error || "Doctor profile not found."}</p>
          <Button onClick={() => navigate("/medical-board")}>Back to Medical Board</Button>
        </Container>
      </div>
    );
  }

  return (
    <section className="dp-profile-page">
      <Container fluid className="dp-profile-page__container">
        <DoctorProfileView doctor={doctor} />
      </Container>
    </section>
  );
};
